export default __webpack_public_path__ + "static/media/qr-code-white.4ed6a40d.svg";